export function escapeHtml(text: string): string {
  return (text || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function compactText(text: string): string {
  // First, remove newlines inside <ul> and <ol> tags to prevent extra bullets in Slack
  const result = text.replace(/<(ul|ol)>([\s\S]*?)<\/\1>/g, (match, tag, content) => {
    const compactedContent = content.replace(/\n\s*/g, "");
    return `<${tag}>${compactedContent}</${tag}>`;
  });

  // Then trim each line and join with newlines
  return result.split("\n").map((line) => line.trim()).join("\n");
}

export function makeListHtml(items: string[]): string {
  if (!items || items.length === 0) return "";
  return compactText(`<ul>${items.map((t) => `<li>${escapeHtml(t)}</li>`).join("")}</ul>`);
}

// Accepts pre-built HTML strings as items (no escaping). Use when items already contain markup.
export function makeListHtmlRaw(items: string[]): string {
  if (!items || items.length === 0) return "";
  return compactText(`<ul>${items.map((t) => `<li>${t}</li>`).join("")}</ul>`);
}
